export const CheckMark = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#2A9D8F" />
      <path
        d="M6.87361 11.1514L12 5.87578L11.2373 5.09082L6.87361 9.58151L4.76275 7.40918L4 8.19414L6.87361 11.1514Z"
        fill="white"
      />
    </svg>
  );
};
